<!--<div class="navbar-top__country-select d-none d-lg-flex">-->
<!--  <div class="campus-select" dropdown>-->
<!--    <button class="btn btn&#45;&#45;campus-selector mb-0" dropdownToggle>-->
<!--    <span class="campus-name">-->
<!--      {{ getSelectedCampusName() }}-->
<!--    </span>-->
<!--      <svg class="campus-btn__arrow" fill="none" height="7"-->
<!--           viewBox="0 0 11 7" width="11" xmlns="http://www.w3.org/2000/svg">-->
<!--        <path-->
<!--          d="M5.07672 4.43901L8.78526 0.677043C8.95052 0.509312 9.21495 0.511023 9.38021 0.680466L10.0297 1.3531C10.195 1.52597 10.195 1.80324 10.028 1.97439L5.37585 6.76157C5.29322 6.84715 5.1858 6.88993 5.07672 6.88993C4.96765 6.88993 4.86022 6.84715 4.77759 6.76157L0.125395 1.97439C-0.0415219 1.80324 -0.0415219 1.52597 0.123743 1.3531L0.773232 0.680466C0.938497 0.511023 1.20292 0.509312 1.36818 0.677043L5.07672 4.43901Z"-->
<!--          fill="#454545"/>-->
<!--      </svg>-->
<!--    </button>-->

<!--<div *dropdownMenu class="dropdown-menu dropdown-menu&#45;&#45;campus" role="menu">-->
<!--  <div *ngFor="let campus of campuses" class="campus-radio-item">-->
<!--    <label-->
<!--      class="campus-radio-label"-->
<!--      [ngClass]="{ active: campus.id === selectedCampusId }"-->
<!--    >-->
<!--      <input-->
<!--        type="radio"-->
<!--        name="campus-selector"-->
<!--        [value]="campus.id"-->
<!--        [checked]="campus.id === selectedCampusId"-->
<!--        (change)="onCampusRadioChange(campus.id)"-->
<!--        class="campus-radio-input"-->
<!--      />-->
<!--      <span class="campus-radio-custom"></span>-->
<!--      <span class="campus-item__name">{{ campus.name }}</span>-->
<!--    </label>-->
<!--  </div>-->
<!--</div>-->
<!--  </div>-->
<!--</div>-->

<div class="campus" dropdown>
  <!-- Select Button -->
  <button class="btn btn--topnav-dropmenu-selector campus-button" dropdownToggle>
    <span class="topnav-dropmenu">
      <div [innerText]="getSelectedCampusName() | translate" class="campus-name"></div>
    </span>
  </button>

  <!-- Dropdown Menu -->
  <div *dropdownMenu class="dropdown-menu dropdown-menu--campus" role="menu" id="campus-link-dropdown">
    @for (campus of campuses; track campus) {
      <div class="campus-radio-item">
        <button
          class="campus-radio-label"
          [ngClass]="{ active: campus.id === selectedCampusId }"
          (click)="onCampusRadioChange(campus.id)"
          (keydown.enter)="onCampusRadioChange(campus.id)"
          [attr.aria-label]="`${'Select campus: ' + campus.name}` | translate">
          <span class="campus-radio-custom"></span>
          <span class="campus-item__name">{{ campus.name | translate }}</span>
        </button>
      </div>
    }
  </div>
</div>

<!--<div *ngIf="isMultiLanguage() && !isLargeBreakpoint" [innerText]="getLanguageName(getCurrentLanguage()) | translate"-->
<!--     class="language-current text-uppercase"></div>-->

<!--<ng-template #languageSelect>-->
<!--  <div class="modal-header language-modal-header">-->
<!--    <h5>{{'Select your language' | translate}}</h5>-->
<!--  </div>-->
<!--  <div class="modal-body">-->
<!--    <div *ngFor="let language of languages$" [ngClass]="{'active' : language.code === ''}"-->
<!--         class="mb-3">-->
<!--      <a (click)="setLanguage(language)" [core-analytics]="{action: language.name, block}" [innerText]="language.name"-->
<!--         class="btn btn&#45;&#45;country" href="javascript:void(0)"></a>-->
<!--    </div>-->
<!--  </div>-->
<!--</ng-template>-->
